import styled from 'styled-components';
export const IllustrationRoot = styled.svg.withConfig({
  componentId: "ds__sc-4jo198-0"
})(["flex-shrink:0;"]);